<script setup lang="ts"></script>

<template>
  <div class="gpx-button-group">
    <slot />
  </div>
</template>

<style scoped>
.gpx-button-group {
  display: flex;
}
</style>

<style>
.gpx-button-group .gpx-button {
  white-space: nowrap;
}

.gpx-button-group .gpx-button:first-child {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
}

.gpx-button-group .gpx-button:last-child {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
}

.gpx-button-group .gpx-button:not(:last-child) {
  border-right-width: 0;
}

.gpx-button-group .gpx-button:not(:first-child, :last-child) {
  border-radius: 0;
}
</style>
